import React from 'react';

export type ViewRenderMode = 'full' | 'title-only';

export interface ViewContextType {
  title: string;
  setTitle: (title: string) => void;
  panelIdx: number;
  renderMode: ViewRenderMode;
}

export const ViewContext = React.createContext<ViewContextType>({
  title: '',
  setTitle: () => {},
  panelIdx: 0,
  renderMode: 'full',
});

export function useViewContext(): ViewContextType {
  return React.useContext(ViewContext);
}
